    const yearOptions = (() => {
      const currentYear = new Date().getFullYear();
      return Array.from({ length: currentYear - 1960 + 6 }, (_, i) => {
        const year = String(currentYear + 5 - i);
        return { value: year, label: year };
      });
    })();

    export default yearOptions;